define('app/sss/execution/queue/sss-execution-queue-factory',["$timeout", "$q"], function ($timeout, $q) {

	function merge(obj1, obj2) {
		var proto1, proto2, finalProto, merged;
		function merge(x, y) {
			if (angular.isObject(x)) {
				angular.forEach(y, function (value, key) {
					if (!(key in x) || !angular.isObject(x[key])) {
						x[key] = angular.copy(value, true);
					}
					else {
						x[key] = merge(x[key], value);
					}
				});
			}
			return x;
		}

		if (angular.isObject(obj1)) {
			var proto1 = Object.getPrototypeOf(obj1);
		}
		if (angular.isObject(obj2)) {
			var proto2 = Object.getPrototypeOf(obj2);
		}
		var finalProto = proto1 === proto2 ? proto1 : merge(proto1, proto2);
		var merged = angular.copy(obj1);

		merge(merged, obj2);
		return merged
	}

	ExecutionQueue.merge = merge;
	return ExecutionQueue;
	function ExecutionQueue(executor, collisionHandler) {
		var timeout;
		var executionItems = {};

		function defaultCollisionHandler(newValue, oldValue) {
			return newValue;
		}

		function mergeCollisionHandler(newValue, oldValue) {
			return merge(newValue, oldValue);
		}

		switch (collisionHandler) {
			case "merge":
				collisionHandler = mergeCollisionHandler;
			default:
				if (!angular.isFunction(collisionHandler)) {
					collisionHandler = defaultCollisionHandler;
				}
				break;
		}

		function generateTimeout() {
			if (!timeout) {
				timeout = $timeout(function () {
					timeout = undefined;
					angular.forEach(executionItems, function (executionItem, key) {
						delete executionItems[key];
						var item = executionItem.item;
						var deferred = executionItem.deferred;
						executor(key, item).then(function () {
							deferred.resolve.apply(deferred, arguments);
						}, function () {
							deferred.reject.apply(deferred, arguments);
						}, function () {
							deferred.notify.apply(deferred, arguments);
						});
					});
				});
			}
		}

		return {
			queueItem: function queueItem(key, item) {
				generateTimeout();
				var deferred;
				var executionItem = executionItems[key] || {};
				executionItem.item = collisionHandler(item, executionItem.item);
				executionItems[key] = executionItem;
				if (executionItem.deferred) {
					return executionItem.deferred.promise;
				}
				else {
					deferred = executionItem.deferred = $q.defer();
					return deferred.promise;
				}
			}
		};
	}
});
